import type { Params } from "../toQueryString";
import { toQueryString } from "../toQueryString";

export const buildPath = (path: string, params: Params = {}) =>
  `${path}?${toQueryString(params)}`;
